import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { CommandMenuClient } from 'src/WebApiController';

export const useCommandMenuOptions = () => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const queryKey = useMemo(
    () => [
      'CommandMenuClient.GetCommandMenuOptions',
      activeAccountWebClientConfig.activeAccountId,
    ],
    [activeAccountWebClientConfig.activeAccountId]
  );

  const commandMenuOptionsQuery = useQuery({
    queryKey,
    queryFn: async () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }

      return await new CommandMenuClient(
        activeAccountWebClientConfig
      ).getCommandMenuOptions();
    },
    enabled: activeAccountWebClientConfig.activeAccountId != null,
    staleTime: Infinity,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog('CommandMenuClient.GetCommandMenuOptions', error);
      },
    },
  });

  return {
    data: commandMenuOptionsQuery.data,
    isLoading: commandMenuOptionsQuery.isLoading,
  };
};
